<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />

    <device-bar
      :open="true"
      noclose
      modalMode
      :modalActive="getData"
      @update=""
      @load-devices=""
      @close=""
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'

// Типы для данных
interface LinksModalData {
  getLinks?: (options?: any) => Promise<any[]>
  [key: string]: any
}

interface DeviceItem {
  $id?: string
  name?: string
  cls?: string
  device_type?: string
  consume?: any
  [key: string]: any
}

interface BarState {
  location: {
    create: { open: boolean }
    update: { open: boolean }
  }
  device: { open: boolean }
  book: {
    activeBook: any | null
    open: boolean
  }
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableRow {
  name?: string
  device_type?: string
  consume?: any
  $id?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

export default Vue.extend({
  name: 'LINKS_MODAL',

  components: {
    loadingCircle,
    DeviceBar,
  },

  props: {
    data: {
      type: Object as () => LinksModalData,
      default: () => ({})
    },
  },

  data(): {
    loader: boolean
    devices: DeviceItem[]
    bar: BarState
    options: OptionsData
    filter: any | null
    search: string
    table: TableData
  } {
    return {
      loader: false,
      devices: [],
      bar: {
        location: {
          create: { open: false },
          update: { open: false },
        },
        device: { open: false },
        book: {
          activeBook: null,
          open: false
        },
      },
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          endpoint: { width: '40%' },
          check: { width: '20%' },
        },
      },
      filter: null,
      search: '',
      table: {
        columns: [
          {
            title: 'device',
            value: 'name',
            type: 'text',
            width: '50%'
          },
          {
            title: 'device_type',
            value: 'device_type',
            type: 'text',
            width: '30'
          },
          {
            title: 'consume',
            value: 'consume',
            type: 'text',
            width: '20%'
          }
        ],
        rows: []
      },
    }
  },

  computed: {
    getData(): LinksModalData {
      return this.data
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      this.loadDevices()
      this.reset()
      this.statusUnsubscribe('LINKS_MODAL')
    },

    async loadDevices(): Promise<void> {
      try {
        this.setLoader('loadDevices', true)
        this.devices = []
        
        const data$ = await this.getData.getLinks?.({ compute: 'is_used' })
        
        if (data$?.length) {
          data$.forEach((child: DeviceItem) => {
            if (child.cls === 'device') {
              this.devices.push(child)
            }
          })
        }
        
        this.setLoader('loadDevices', false)
        this.prepareTable()
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadDevices', err)
        this.setLoader('loadDevices', false)
        this.loader = false
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async prepareTable(): Promise<void> {
      try {
        if (this.devices.length) {
          this.loader = true
          
          this.devices.forEach((child: DeviceItem) => {
            const row$: TableRow = {
              name: child.name,
              device_type: child.device_type,
              consume: child.consume,
              $id: child.$id
            }
            this.table.rows.push(row$)
          })
          
          this.loader = false
          this.statusSubscribe(this.devices, 'LINKS_MODAL')
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }
    },

    async statusSubscribe(arr: DeviceItem[], group: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      
      if (arr.length) {
        arr.forEach((item: DeviceItem) => {
          if (item.$id) {
            this.$store.dispatch('addStatusKey', item)
          }
        })
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset(): void {
      this.table.rows = []
    }
  }
})
</script>

<style scoped lang="less">

</style>
